import { BaseApiResponse } from '../../types/api.types';
import instance from './axios';

const ENDPOINTS = {
  SLIDER: '/sliders',
};

const getSliders = (id: number) => {
  return instance.get<BaseApiResponse>(ENDPOINTS.SLIDER + `/${id}`);
};

const HomeApi = {
  getSliders,
};

export default HomeApi;
